import { useEffect } from 'react';

import { useExportPreview } from '@/features/DataHub/modules/Export/context/exportContexts';

export const usePreviewDownload = (downloadFile: (() => void) | undefined, isReady: boolean) => {
  const { setPreviewDownloadFn } = useExportPreview();

  useEffect(() => {
    if (downloadFile && isReady) {
      setPreviewDownloadFn(() => downloadFile);
    }
    return () => {
      setPreviewDownloadFn(null);
    };
  }, [downloadFile, isReady, setPreviewDownloadFn]);
};
